const plans = {
	namespaced: true,
	state: {
		plans: [],
	},
	getters: {
		getPlans(state){
			return state.plans
		}
	},
	mutations: {
		setPlans(state, plans){
			state.plans = plans;
		}
	},
	actions: {
		setPlans({ commit }, plans){
			commit('setPlans', plans)
		}
	}
}

export default plans;


// WEBPACK FOOTER //
// ./src/store/plans.js